module.exports = __webpack_public_path__ + "static/img/resume-left-right-rtl.72d9266.png";